export function isAsyncCourse(data: any): boolean {
  if (data == null) return false;

  const preRecorded =
    data.preRecordedOption ??
    data.CourseItem?.preRecordedOption ??
    data.courseItem?.preRecordedOption;

  const normalized =
    preRecorded != null && preRecorded !== 1
      ? String(preRecorded).toUpperCase()
      : '';

  return (
    normalized === 'ASYNC' ||
    normalized === 'ANYTIME' ||
    preRecorded === 1 ||
    data.isAsync === true ||
    data.sessionStartDisplay === 'ASYNC'
  );
}
